(function () {
    angular.module('Directives').directive('bbaProfileMeasureUnit', bbaProfileMeasureUnit);

    bbaProfileMeasureUnit.$inject = [
        '$q',
        'Location',
        'Units'
    ];

    function bbaProfileMeasureUnit() {
            return {
                restrict: 'E',
                templateUrl: '/templates/directives/components/bba-profile-manager/bba-profile-measure-unit.html',
                scope: {
                    step: '=',
                    isViewMode: '=?',
                    init: '=',
                    disabled: '='
                },
                controller: bbaProfileMeasureUnitController,
                controllerAs: 'vm',
                bindToController: true
            };
        }
    
        function bbaProfileMeasureUnitController($scope,Units){
            let vm = this;
            vm.Units = Units;
            vm.unitList = [];
            vm.samplePackage = samplePackage;

            $scope.$watch(angular.bind(this, () => this.init), value => {
                if (value) init();
            });

            function init(){
                getUnits();
            }

            function getUnits(){
                const units = vm.Units.measureUnit;
                for(let i =0; i < units.length;i++){
                    vm.unitList.push({
                        name: `${vm.Units.weightUnit[i].short} / ${vm.Units.measureUnit[i].short}`,
                        weightUnit: {
                            long:vm.Units.weightUnit[i].full,
                            short: vm.Units.weightUnit[i].short
                        },
                        measureUnit: {
                            long:vm.Units.measureUnit[i].full,
                            short: vm.Units.measureUnit[i].short
                        }
                    })
                }
                samplePackage();
            }

            function samplePackage (){
                if(!vm.selectUnits){
                    vm.selectUnits = {
                        measureUnit: {long: 'Centimeters', short: 'cm'},
                        name: "kg / cm",
                        weightUnit: {long: 'Kilograms', short: 'kg'}
                    }
                }
                vm.samplePackage = {
                    height:5,
                    measureUnit: vm.selectUnits.measureUnit.short,
                    length: 5 ,
                    quantity:1,
                    weight:1,
                    contentWeight: vm.samplePackage.weight,
                    weightUnit:vm.selectUnits.weightUnit.long,
                    width:5
                }
                vm.samplePackage.contentWeight = vm.samplePackage.weight
                vm.step.details['packages'] = vm.samplePackage

            }

            $scope.$watch(angular.bind(vm, () => {
                vm.samplePackage.contentWeight = vm.samplePackage.weight;
                vm.step.details['packages'] = vm.samplePackage;
                return this.step.details;
            }), value => {
                
            });
        }
})()


// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaProfileMeasureUnit.js